export const contactInfo = {
    mailTo: "info@mok.ie",
    phone: "(066) 979 0688",
    page: "/page/contact/",
    facebook: "https://www.facebook.com/people/Moriartys-of-Killorglin-The-Furniture-Store/100063565061205/",
    instagram: "https://www.instagram.com/moriartys_of_killorglin/2",
    twitter: "",
    pinterest: "",
    youtube: "",
    linkedin: ""
}

export const contactForm = {
    fields:
    {
        name: {
            required: false,
            showInput: true
        },
        email: {
            required: false,
            showInput: true
        },
        phone: {
            required: false,
            showInput: true
        },
        storeName: {
            required: false,
            showInput: false
        },
        message: {
            required: false,
            showInput: true
        },

    }
}

export const sendAMessage = {
    title: 'Contact',
    subtitle: 'Send Us a Message',
    description: 'Fill in the contact form and our team will get back to you as soon as possible.',
    callUs: {
        title: 'Call Us',
        subtitle: 'Our friendly and knowledgeable staff would be delighted to help you.',
    }
}

export const storeLocations = {
    title: 'Store Locations',
    subtitle: 'Come and visit us today our doors are always open well between 9-6 that is!!!! If you cannot make it within normal hours, we will do our best to accommodate you with an out of hours appointment.',
    where: {
        title: 'WHERE WE OPERATE',
        subtitle: 'Iveragh Road, Killorglin, Co Kerry. V93ED26',
        urlMap: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d4901.389032843617!2d-9.79831!3d52.103491!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x484545eeae366a2d%3A0x388bdf298720c55b!2sIveragh%20Rd%2C%20Co.%20Kerry%2C%20Ireland!5e0!3m2!1sen!2sus!4v1739908184664!5m2!1sen!2sus'
    },
    opening: {
        title: 'Opening Hours',
        subtitle: 'Monday-Friday  /  Saturday'
    }
}

export const  socialMediaMetadataInfo = {    
    urlImageSocial: '',
    urlTwitterImage: '',
}

export const showCaptcha = {
    visible: false,
    sitekey: "2ce7ad9b-d0ba-4b4a-b453-30dcdf4448ba", // (hcaptcha email= info@thewebsystem.com , password =BCEjzWCv_emg4R3)
    language: 'en'
}